<template>
  <div v-if="prepareTransferList.length > 0">
    <p style="margin: 20px 0 5px;"><strong>Transfer: </strong> </p>
    <table style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%" class="avoid">
      <tr style="background: #f3f3f3" class="avoid">
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Transfer Name</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Price Per Way</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Unit</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Min Pax</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Max Pax</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Condition</strong></p>
        </th>
      </tr>
      <tr v-for="(transfer) of prepareTransferList" :key="`transfer-${transfer.id}`" class="avoid">
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{transfer.name}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{numberFormat(transfer.price)}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{bindBindTransferUnit(transfer.unitType)}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{transfer.minPax}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{transfer.maxPax}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top;">
          <p>{{transfer.conditionDetail}}</p>
        </td>
      </tr>
    </table>
    <div v-if="bindTransferRemark().trim() !== ''" class="editor-preview avoid">
      <p style="margin: 5px 0 5px;">
        <strong>Remark: </strong>
      </p>
      <div class="remark" v-html="bindTransferRemark()"></div>
    </div>
  </div>
</template>
<script>
import { TRANSFER_TYPE, REMARK_TYPE } from '@/configs/constant'
import { numberFormat } from '@/helpers'
import { applyRemarkTableStyle } from '@/domains/contract-domain'

export default {
  name: 'Transfer',
  props: {
    transferList: {
      type: Array,
      default: () => {
        return []
      }
    },
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    prepareTransferList: function () {
      const transferList = this.transferList || []

      return transferList
    }
  },
  data: function () {
    return {
      numberFormat: (number) => {
        return numberFormat(number)
      }
    }
  },
  methods: {
    bindBindTransferUnit: function (unitType) {
      if (unitType === TRANSFER_TYPE.PER_CAR) {
        return 'Per Car'
      }
      if (unitType === TRANSFER_TYPE.PER_PERSON) {
        return 'Per Person'
      }
      return '-'
    },
    bindTransferRemark: function () {
      const remark = applyRemarkTableStyle(this.remarkList, REMARK_TYPE.TRANSFER)

      return remark
    }
  }
}
</script>
<style scoped>
  p {
    display: block;
    margin-block-start: 0px;
    margin-block-end:0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .remark > p {
    margin: 5px 0 10px;
  }
</style>
